module.exports = __webpack_public_path__ + "static/media/original-medicare-card.895605e1.jpg";